import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'react-router-dom';
import { Layout } from 'antd/lib';

import RutaAutenticada from '../auth/RutaAutenticada';
import * as Roles from '../common/DeclaracionRoles';

import CrearExpediente from './expediente/CrearExpediente';
import CrearTipoExpediente from './tipoExpediente/CrearTipoExpediente';
import ListarTipoExpedientes from './tipoExpediente/ListarTipoExpedientes';
import VerTipoExpediente from './tipoExpediente/VerTipoExpediente';
import VerExpediente from './expediente/VerExpediente';
import ListarExpedientes from './expediente/ListarExpedientes';
import AgregarActuacion from './expediente/AgregarActuacion';
import EditarActuacion from './expediente/EditarActuacion';

import BuscarExpedientesContraventor from './expediente/buscar/BuscarExpedientesContraventor';
import BuscarPorCodigo from './expediente/buscar/BuscarPorCodigo';
import ContainerGraficos from './estadisticas/ContainerGraficos';

class Index extends React.PureComponent {
  render() {
    const { Content } = Layout;

    return (
      <Layout
        style={{
          padding: '0 24px 24px',
        }}
      >
        <Content
          style={{
            padding: '0 24px 24px 24px',
            margin: 0,
          }}
        >
          <Switch>
            <RutaAutenticada
              exact
              path={`${this.props.match.url}/expedientes/nuevo`}
              component={CrearExpediente}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/expedientes/:id/agregarActuacion`}
              component={AgregarActuacion}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/expedientes/:id`}
              component={VerExpediente}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/actuacion/:id`}
              component={EditarActuacion}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/tipoExpedientes/nuevo`}
              component={CrearTipoExpediente}
              rolesAutorizados={[Roles.CONFIGURACION, Roles.SUPERVISOR]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/expedientes`}
              component={ListarExpedientes}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
                Roles.DGJP_DIRECTOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/tipoExpedientes/:id`}
              component={VerTipoExpediente}
              rolesAutorizados={[Roles.CONFIGURACION, Roles.SUPERVISOR]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/tipoExpedientes`}
              component={ListarTipoExpedientes}
              rolesAutorizados={[Roles.CONFIGURACION, Roles.SUPERVISOR]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/buscarExpedientes`}
              component={BuscarExpedientesContraventor}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/buscarPorCodigo`}
              component={BuscarPorCodigo}
              rolesAutorizados={[
                Roles.MESA_DE_ENTRADA,
                Roles.DESPACHO,
                Roles.FUNCIONARIO,
                Roles.SUPERVISOR,
              ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/estadisticias`}
              component={ContainerGraficos}
              rolesAutorizados={[Roles.SUPERVISOR]}
            />
          </Switch>
        </Content>
      </Layout>
    );
  }
}

Index.propTypes = {
  match: PropTypes.object.isRequired,
};

export default Index;
